import {shallowRef} from '@vue/reactivity'

class RemoteStream {
  constructor() {
    this.video = shallowRef()
    this.audio = shallowRef([])
  }
}

const remoteStream = new RemoteStream()
export {remoteStream}